<template>
    <div class="wrapper landing-page">
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/tjn-bck.jpg')">
            </parallax>
            <div class="content-center">
                <h1 class="title">{{webSiteBilgileri.PodCastAdi}}</h1>
                <h5 class="description">{{webSiteBilgileri.Slogan}}</h5>
                <div class="text-center">
                    <a href="https://www.instagram.com/tijenhoca/" class="btn btn-primary btn-icon  btn-round">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a href="https://twitter.com/tijentangulse" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="https://www.facebook.com/pages/Tijen-Hoca/208586643077901" class="btn btn-primary btn-icon btn-round">
                        <i class="fab fa-facebook"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="features-5" v-if="podCasts.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col col-sm-5 col-md-5 col-12">
                        <div class="tablet-container">
                            <!--                            <img v-lazy="'http://localhost:1337' + podCasts[0].KapakResmi.url" />-->
                            <img v-lazy="frontend_address  + webSiteBilgileri.podcast_image.url" />
                        </div>
                    </div>
                        <div class="col col-sm-7 col-md-7 col-12 text-center">
                            <h2 class="title">İngilizce Atölyesi Bölüm #{{podCasts.length > 0 ? podCasts[0].BolumNo : 0}}</h2>
                            <h5 class="title">{{podCasts[0].Adi}}</h5>
                            <div class="info info-horizontal">
                                <div class="">
                                    <h4 class="info-title">İçerik</h4>
                                    <div style="white-space: pre-line;" v-html=podCasts[0].Aciklama></div>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 40px">
                                <div class="col-sm-12 col-md-4 el-col-xs-12 col-4" >
                                    <a href="https://open.spotify.com/show/2BnQdviypmoMSTY50cIjhU" target="_blank">
                                        <img  src="img/Spotify_Logo_RGB_Green.png">
                                    </a>
                                </div>
<!--                                <div class="col-6" style="padding-top: 10px" >-->
<!--                                    <img src="img/TR_Apple_Podcasts_Listen_Badge_RGB.svg">-->
<!--                                </div>-->
                            </div>
                            <div class="row" style="margin-top: 40px">
                                <video controlsList="nodownload" controls :poster="frontend_address +webSiteBilgileri.podcast_image.url">
                                    <source :src="frontend_address +podCasts[0].PodCastDosyasi.url" type="audio/mpeg" />
                                </video>
                            </div>
                        </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput, Tabs, TabPane } from '@/components';
  import gql from "graphql-tag";
  export default {
    name: 'landing-page',
    bodyClass: 'landing-page',
    components: {
      Card,
      Tabs,
      TabPane,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          message: '',
        },
        webSiteBilgileri: {SiteAdi: '', KatildigimIsler:[],podcast_image:{}},
        frontend_address: process.env.VUE_APP_FRONTEND_ADDRESS,
        podCasts: [],
        routeParam: this.$route.params.pid
      }
    },
    apollo: {
      webSiteBilgileri: {query: gql`
      query webSiteBilgileri {
        webSiteBilgileri {
          id
          SiteAdi
          tags
          PodCastAdi
          PodCastKonusu
          Slogan
          created_at
          updated_at
          podcast_image {
            url
          }
          KatildigimIsler {
            id
            Baslik
            KisaAciklama
            icon
            ArkaPlanResmi {
              url
              previewUrl
            }
            link
          }
        }
      }
    `},
      podCasts: {
        query: gql`
           query podCasts($id: Int) {
            podCasts(where : {id: $id}) {
              id,
              BolumNo,
              Tarih,
              Adi,
              KisaAciklama,
              KapakResmi {
                url
              },
              PodCastDosyasi{
                url
              },
              Aciklama,
              Tags{
                Tag
              }
            }
           }
        `,
          variables() {
            return {
              id: Number(this.routeParam)
            };
          }
      }
    }
  }
</script>
<style>
    video[poster]{
        height:200px;
        width:300px;
    }
</style>
